export function Logo({ width }) {
    return (
        <>
            <div className="mb-3">
                <img src="assets/img/icon/128x128.png" alt="image" className="imaged square" style={{ width: width }} />
            </div>
        </>
    );
}
